import { GridCellParams } from '@mui/x-data-grid';
import { OnboardDeviceConnectionStatus } from '../../interfaces';
import { CopyButton } from '../CopyButton';
import { LongTextCellWrapper } from './CopyTextCell';

const ONLINE_STATUS: OnboardDeviceConnectionStatus = 'online';
const ONLINE_STATUS_COLOR = '#2e7d32';
const ONLINE_STATUS_LABEL = 'Online';

export const DeviceSerialStatusCell = (cellValues: GridCellParams) => {
    const status = cellValues.row.onlineConnectionStatus as OnboardDeviceConnectionStatus | undefined;
    const serialText = cellValues.value == null ? '' : String(cellValues.value);

    return (
        <LongTextCellWrapper style={{ alignItems: 'center', gap: 8 }}>
            {status === ONLINE_STATUS && (
                <span
                    title={ONLINE_STATUS_LABEL}
                    aria-label={ONLINE_STATUS_LABEL}
                    style={{
                        width: 10,
                        height: 10,
                        minWidth: 10,
                        minHeight: 10,
                        borderRadius: '50%',
                        backgroundColor: ONLINE_STATUS_COLOR,
                        display: 'inline-block',
                    }}
                />
            )}
            {serialText ? (
                <>
                    <span
                        style={{
                            fontFamily: 'ui-monospace, monospace',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {serialText}
                    </span>
                    <span className="copy-btn">
                        <CopyButton value={serialText} />
                    </span>
                </>
            ) : (
                <span>-</span>
            )}
        </LongTextCellWrapper>
    );
};
